import {
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  inject,
  signal,
  computed,
  OnChanges,
  AfterViewInit,
  OnDestroy,
  input,
  ChangeDetectionStrategy,
  WritableSignal,
  SimpleChanges,
  EventEmitter,
  Output,
} from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { HttpErrorResponse } from '@angular/common/http';

import { Subject, take, takeUntil } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

import { AngularModule, MaterialModule } from '@shared/modules';
import { Utils } from '@shared/utils';

import { RespDialogI, UnsubscribeSubject } from '@shared/interface';
import { ErrorManagementService } from '@shared/services';
import { messages as msg } from '@env/environment';
import { TableService } from './table.service';
import { SpinnerComponent } from '../spinner/spinner.component';
import { CargandoComponent } from '../cargando/cargando.component';
import { EstaSeguroComponent } from '../esta-seguro/esta-seguro.component';
import { ListDataColumnsI } from './table.interface';
import { ActionsI } from 'app/usuario/portal/portal.iterface';
import { PageEvent } from '@angular/material/paginator';
import { entityNameMap } from '@constants/entity-name';
import { NoDataTableComponent } from '../no-data-table/no-data-table.component';
import { InfoMessageComponent } from '../info-message/info-message.component';
import { ColumnConfigService } from './column-config.service';
import { actionsUser } from '@constants/actions.constants';
import { LayoutService } from '@layout/layout.service';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
  standalone: true,
  imports: [AngularModule, MaterialModule, SpinnerComponent, CargandoComponent, NoDataTableComponent, InfoMessageComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  lastKey = '';
  isOrderIcon = false;

  @Input() reportEntity = '';
  @Input() reportFields = '';
  @Input() reportOrderByField = '';
  @Input() excludeColumns: string[] = [];
  @Input() screenId!: string;

  public nameHeaderTable = input<Record<string, string>>({});
  public customDownload = input<boolean>(false);
  public titulo = input<string>();
  public columnsHeaderTable: string[] = [];
  public columnsHeaderTableClone: string[] = [];

  public listDataTable: WritableSignal<any[]> = signal<any[]>([]);

  @Input() keyFilter: string[] = [];
  @Input() routeSelectFn!: any[];
  @Input() clickAction: Function = () => {};
  nameBtn = input<string>('');
  isBtnVert = input<boolean>(false);
  isRedirectToChild = input<boolean>(false);

  @Input() acciones: {
    key: string;
    event: Function;
    icon?: string | undefined;
    tooltip?: string | undefined;
    isClick?: boolean | undefined;

    isEdit?: boolean | undefined;
    isDelete?: boolean | undefined;
    isVisualizar?: boolean | undefined;
    isSections?: boolean | undefined;
    isElecciones?: boolean | undefined;
    isBtnVert?: boolean | undefined;
    isRedirectToChild?: boolean | undefined;
  }[] = [];

  @Input() pageTitle = '';
  @Input() accionOrder: Function = () => {};

  public isSpinner = signal<boolean>(true);
  searchFormFilterOriginal: any[] = [];
  searchFormFilter: any[] = [];
  private actionsHeaders = signal<ActionsI>({} as ActionsI);

  // ========= Estados de los iconos ==========
  public isVisibleActions = signal<boolean>(true);
  public isIconDelete = signal<boolean>(false);
  public isIconEdit = signal<boolean>(false);
  public isIconView = signal<boolean>(false);
  public isIconVert = signal<boolean>(false);

  // ================== Verificar si existen datos en la tabla ==================
  public isVisibleBodyTable = signal<boolean>(true);
  public isVisibleTableHeader = signal<boolean>(true);
  public isVisiblePagination = signal<boolean>(true);
  public isVisibleBtnDescargar = signal<boolean>(true);
  public isVisibleBtnColumnas = signal<boolean>(true);
  public isVisibleBtnCrear = signal<boolean>(true);
  public isVisibleColumnActions = signal<boolean>(true);
  public isExistDataTable = signal<boolean>(true);

  // ========= Actions que puede realizar el usuario ==========
  public viewSpinner = signal<boolean>(true);
  public allowConsulta = signal<boolean>(true);
  public allowBaja = signal<boolean>(true);
  public allowModificar = signal<boolean>(true);
  public allowExportar = signal<boolean>(true);
  public allowEjecutar = signal<boolean>(true);

  // ===== Estados boton filtrar columnas ======
  private searchFormFilterColumn: any[] = [];
  private removedColumnsSet: string[] = [];
  private checkColumnsOriginal: any[] = [];
  private isExisteDataSearchForm = signal<boolean>(true);

  public listDataColumns: WritableSignal<ListDataColumnsI[]> = signal<ListDataColumnsI[]>([]);
  private checkColumnsFilter = signal<ListDataColumnsI[]>([]);
  private listDataTableClone = signal<any[]>([]);

  // ========== Paginación ==========
  @Input() totalItems = 0;
  @Input() pageSize = 25;
  @Input() pageIndex = 0;
  @Output() pageChange = new EventEmitter<PageEvent>();

  // =========== Ocultar o mostrar columnas de la tabla dependiendo de la selección ===========
  public isViewDataTable = signal<boolean>(true);

  listarAlertado: any[] = [];

  public isShowColumn = false;
  isShowBtnVert = false;
  isDataTable = true;
  isLoading = signal<boolean>(true);
  public isDescargando = signal<boolean>(true);

  public sortedColumn = '';
  public sortDirection: 'asc' | 'desc' = 'asc';
  private dataFormSearch = signal({});
  public entityName = signal<string>('');

  public filaPorHojaForm!: FormGroup;
  public filterTableForm!: FormGroup;

  //  =============== dependency injection ===============

  private readonly _unsubscribeAll: UnsubscribeSubject = new Subject<void>();

  private readonly _fb = inject(FormBuilder);
  private readonly _cd = inject(ChangeDetectorRef);
  private readonly _dialog = inject(MatDialog);
  private readonly _toastr = inject(ToastrService);

  private readonly _msg = msg;
  private readonly _errorManagementService = inject(ErrorManagementService);
  private readonly _tableSvc = inject(TableService);
  private readonly _layoutSvc = inject(LayoutService);
  private readonly _utils = inject(Utils);
  private readonly _columnConfigSvc = inject(ColumnConfigService);

  public loading = computed(() => this.isLoading());

  constructor() {
    this.filterTableForm = this._fb.group({});
  }

  ngOnInit() {
    this._tableSvc.setBusquedaAnidada({});
    this.getEntityName();
    this.listDataTable.set([]);
    this.initStatesIcons();
    this.listDataTableObs();
    this.nameActions();
  }

  ngAfterViewInit(): void {
    this._cd.markForCheck();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['listDataTable'] && changes['listDataTable'].currentValue !== changes['listDataTable'].previousValue) {
      this.listDataTableObs();
    }

    this._tableSvc.spinner$.subscribe((state: any) => {
      this.isSpinner.set(state);
    });

    if (changes['listDataTable'] && changes['listDataTable'].currentValue !== changes['listDataTable'].previousValue) {
      this.initStatesIcons();
    }

    if (changes['reportEntity'] || changes['reportFields'] || changes['reportOrderByField']) {
      // this.cargarData();
      this.listDataTableObs();
    }
  }

  // ================ Estados de los iconos ================
  private initStatesIcons(): void {
    this.existDataTable();
    this.isSpinnerComponent();
    this.isConsulta();
    this.isIconDeleted();
    this.isIconEdited();
    this.isIconViewed();
    this.isIconVertical();

    this.isExportar();
    this.isModdificar();
    this.isBaja();

    // this.rolPermissionsActions();
    this.userPermissions();
    this.isVisablTable();
  }

  private isIconDeleted(): void {
    this._tableSvc.isIconDelete$.subscribe((state: boolean) => this.isIconDelete.set(state));
  }
  private isIconEdited(): void {
    this._tableSvc.isIconEdit$.subscribe((state: boolean) => this.isIconEdit.set(state));
  }
  private isIconViewed(): void {
    this._tableSvc.isIconView$.subscribe((state: boolean) => this.isIconView.set(state));
  }
  private isIconVertical(): void {
    this._tableSvc.isIconVert$.subscribe((state: boolean) => this.isIconVert.set(state));
  }

  private isSpinnerComponent(): void {
    this._tableSvc.viewSpinner$.pipe(takeUntil(this._unsubscribeAll)).subscribe((state: boolean) => {
      this.viewSpinner.set(state);
    });
  }

  private existDataTable(): void {
    this._tableSvc.isExistDataTable$.pipe(take(1), takeUntil(this._unsubscribeAll)).subscribe((state: boolean) => {
      this.isExistDataTable.set(state);
    });
  }

  private isConsulta(): void {
    this._tableSvc.isConsulta$.pipe(takeUntil(this._unsubscribeAll)).subscribe((state: boolean) => {
      this.allowConsulta.set(state);
    });
  }

  private isExportar(): void {
    this._tableSvc.isExport$.pipe(takeUntil(this._unsubscribeAll)).subscribe((state: boolean) => {
      this.allowExportar.set(state);
    });
  }

  private isModdificar(): void {
    this._tableSvc.isModificarEditar$.pipe(takeUntil(this._unsubscribeAll)).subscribe((state: boolean) => {
      this.allowModificar.set(state);
    });
  }

  private isBaja(): void {
    this._tableSvc.isEliminar$.pipe(takeUntil(this._unsubscribeAll)).subscribe((state: boolean) => {
      this.allowBaja.set(state);
    });
  }

  private nameActions(): void {
    this._tableSvc.isHeaders$.pipe(take(1)).subscribe((actions: ActionsI) => {
      this.actionsHeaders.set(actions);
    });
  }

  private userPermissions(): void {
    this._tableSvc.userPermissions$.pipe(takeUntil(this._unsubscribeAll)).subscribe((state: string[]) => {
      if (!state || !Array.isArray(state) || state.length === 0) {
        return;
      }

      this.allowBaja.set(state.includes('BAJA') ? true : false);
      this.allowModificar.set(state.includes('MODIFICA') ? true : false);
      this.allowConsulta.set(state.includes('CONSULTA') ? true : false);
      this.allowExportar.set(state.includes('EXPORTAR') ? true : false);
      this.allowEjecutar.set(state.includes('EJECUTAR') ? true : false);
      this._cd.markForCheck();
    });
  }

  private isVisablTable(): void {
    this._tableSvc.isVisibleDataTable$.pipe(takeUntil(this._unsubscribeAll)).subscribe((state: Record<string, boolean>[]) => {
      // Valida si el state es null, undefined o si no es un array vacío
      if (!state || !Array.isArray(state) || state.length === 0) {
        return;
      }

      const defaultState = {
        isViewDataTable: true,
        isVisibleBodyTable: true,
        isVisibleTableHeader: true,
        isVisiblePagination: true,
        isVisibleBtnDescargar: true,
        isVisibleBtnColumnas: true,
        isVisibleBtnCrear: true,
        isVisibleColumnActions: true,
      };

      // Combinar los valores recibidos con los valores por defecto
      const mergedState = state.reduce((acc, curr) => {
        const key = Object.keys(curr)[0];
        acc[key] = curr[key];
        return acc;
      }, defaultState);

      // Aplicar los valores resultantes
      this.isViewDataTable.set(mergedState['isViewDataTable']);
      this.isVisibleBodyTable.set(mergedState['isVisibleBodyTable']);
      this.isVisibleTableHeader.set(mergedState['isVisibleTableHeader']);
      this.isVisiblePagination.set(mergedState['isVisiblePagination']);
      this.isVisibleBtnDescargar.set(mergedState['isVisibleBtnDescargar']);
      this.isVisibleBtnColumnas.set(mergedState['isVisibleBtnColumnas']);
      this.isVisibleBtnCrear.set(mergedState['isVisibleBtnCrear']);
      this.isVisibleColumnActions.set(mergedState['isVisibleColumnActions']);
      this._cd.markForCheck();
      // this.isVisibleBodyTable.set(false);
    });
  }

  private listDataTableObs(): void {
    this._tableSvc.listDataTable$.pipe(takeUntil(this._unsubscribeAll)).subscribe((data: any[]) => {
      if (!data || data.length === 0) {
        this.listDataTable.set([]);
        return;
      }
      this.listDataTable.set(data);
      this.cargarData(data);
      this._cd.markForCheck();
    });
  }

  private cargarData(dataResp: any): any {
    this.listDataTable.set(this.procesarData(dataResp as any[]));
    this.listDataTableClone.set(dataResp);

    this.lastKey = this.obtenerUltimaClave(this.listDataTable());

    // Se obtiene el id y las claves excluidas
    const deleteId = this.obtenerKeysSinId(dataResp);
    const deeteItems = this.filtrarElementosExcluidos(deleteId);

    // Cargar los encabezados y filtros
    this.columnsHeaderTable = deeteItems;
    this.columnsHeaderTableClone = deeteItems;
    this.inicializarFiltros(deleteId);
    this.cargarItemsColumnas(Object.keys(dataResp[0]));
    this.initFilterTable(this.columnsHeaderTable);

    // Actualiza check
    this.updateColumns(this.listDataColumns());

    // Actualizar la tabla y la paginación después de cargar los datos
    this._cd.markForCheck();
  }

  private procesarData(dataTable: any[]): any[] {
    return dataTable.map((dato: any) => ({
      ...dato,
      isShowBtnVert: false,
    }));
  }

  private validarData(dataResp: any[]): boolean {
    return dataResp.length <= 0 || dataResp === null || dataResp === undefined;
  }

  private obtenerUltimaClave(dataTable: any[]): string {
    // De dataTable se extrae los valores con los que se va a polular el botón de las columnas
    const cloneKeys = Object.keys(dataTable[0]);

    // Se retorna el listado de las claves, si existe 'id' se retorna 'id', sino se retorna la primera clave
    return cloneKeys.includes('id') ? 'id' : cloneKeys[0];
  }

  private obtenerKeysSinId(dataResp: any[]): string[] {
    const keys = Object.keys(dataResp[0]);
    return keys.filter((item: string) => item !== 'id' && item !== 'isShowBtnVert');
  }

  private filtrarElementosExcluidos(deleteId: string[]): string[] {
    const exclusionList = ['Creado por', 'Fecha creación', 'Modificado por', 'Fecha modificación'];

    exclusionList.push(...this.excludeColumns);
    return deleteId.filter((item: string) => !exclusionList.includes(item));
  }

  private inicializarFiltros(deleteId: string[]): void {
    this.keyFilter = deleteId;
    this.searchFormFilter = [...deleteId];
    this.searchFormFilterOriginal = [...deleteId];
  }

  private cargarItemsColumnas(keyData: any): void {
    // Filtra y elimina las claves vacías de keyData y las almacena en filteredKeyData
    const filteredKeyData = keyData.filter((key: string) => key !== '');

    // Se crea una lista de exclusiones para las columnas
    const exclusionList = ['Todos', 'Creado por', 'Fecha creación', 'Modificado por', 'Fecha modificación', 'isIcon'];
    exclusionList.push(...(this.excludeColumns ?? []));

    // Se añade 'Todos' y las claves filtradas a la lista de columnas
    const addAllkeys = ['Todos', ...filteredKeyData].filter((item: string) => !this.excludeColumns.includes(item));

    // Se crea un objeto con las columnas y su estado 'checked'
    const checkColumns = addAllkeys.map((key: string, i: number) => {
      // Si la columna está en la lista de exclusión, checked será false, de lo contrario true.
      const checked = !exclusionList.includes(key);
      return {
        id: i,
        title: key,
        checked,
      };
    });

    // Se almacenan las columnas originales
    this.checkColumnsOriginal = checkColumns;
    this.listDataColumns.set(checkColumns);
    this.checkColumnsFilter.set(checkColumns);
  }

  public toggleCheckbox(event: any, itemColumns: any): void {
    const { title, id } = itemColumns;
    const checked = event.target.checked;

    // Si se selecciona o deselecciona "Todos"
    if (title === 'Todos') {
      this.toggleAllCheckedboxes(checked);
    } else {
      this.handleIndividualColumnToggle(id, checked);
    }

    // Actualiza el formulario dinámicamente y fuerza la detección de cambios
    this.updateVisibleColumns();
    this._cd.markForCheck();
  }

  // 1. Maneja la selección/deselección de "Todos" del boton filtrar columnas
  private toggleAllCheckedboxes(checked: boolean): void {
    const updatedColumns = this.listDataColumns().map((column: ListDataColumnsI) => ({
      ...column,
      checked: checked,
    }));

    // Si "Todos" está seleccionado, restaura la tabla original, de lo contrario, la vacía
    this.listDataTable.set(checked ? this.listDataTableClone() : []);
    this.updateColumns(updatedColumns);
  }

  // 2. Maneja la selección de una columna individual
  private handleIndividualColumnToggle(id: number, checked: boolean): void {
    const updatedColumns = this.updateColumnCheckedState(id, checked);
    const allChecked = this.areAllColumnsChecked(updatedColumns);

    // Actualiza el estado del checkbox de "Todos" si corresponde
    updatedColumns[0].checked = allChecked;

    // Procesa las columnas seleccionadas y actualiza los datos de la tabla
    this.updateDataTable(updatedColumns);
    // this.listDataTable.set(checked ? this.listDataTableClone() : []);
    this._cd.markForCheck();
    this.visibleActions(updatedColumns);

    // Clona la tabla de datos para llenarla con la data clonada
    const cloneDataTable = this.listDataTableClone().map((item) => ({ ...item }));
    this.listDataTable.set(cloneDataTable);
  }

  private visibleActions(updatedColumns: any): void {
    // Filtrar para eliminar el elemento con title 'id'
    const filteredColumns = updatedColumns.filter((item: any) => item.title !== 'id');

    // Verificar si al menos un elemento tiene checked en true
    const atLeastOneChecked = filteredColumns.some((check: any) => check.checked === true);

    if (atLeastOneChecked) {
      this.isVisibleActions.set(true);
      this.columnsHeaderTableClone = this.columnsHeaderTable;
    } else {
      this.isVisibleActions.set(false);
      this.columnsHeaderTable = [];
    }
  }

  // 3. Actualiza el estado `checked` de la columna específica seleccionada
  private updateColumnCheckedState(id: number, checked: boolean): ListDataColumnsI[] {
    return this.listDataColumns().map((column: ListDataColumnsI) => ({
      ...column,
      checked: column.id === id ? checked : column.checked,
    }));
  }

  // 4. Verifica si todas las columnas, excepto "Todos", están seleccionadas
  private areAllColumnsChecked(columns: ListDataColumnsI[]): boolean {
    return columns.slice(1).every((col) => col.checked);
  }

  // 5. Verifica si solo la columna 'id' está seleccionada
  private isOnlyIdChecked(columns: ListDataColumnsI[]): boolean {
    return columns.filter((col) => col.checked).length === 1 && columns.some((col) => col.title === 'id' && col.checked);
  }

  // 6. Actualiza la tabla de datos según las columnas seleccionadas
  private updateDataTable(updatedColumns: ListDataColumnsI[]): void {
    const checkedColumnsMap = this.getCheckedColumnsMap(updatedColumns);
    const isOnlyIdChecked = this.isOnlyIdChecked(updatedColumns);

    if (isOnlyIdChecked) {
      // Si solo 'id' está marcado, limpia la tabla y desmarca todos los checks excepto 'id'
      this.clearTableExceptId();
    } else {
      // Filtra los datos de la tabla según las columnas seleccionadas
      // const newData = this.filterDataByCheckedColumns(checkedColumnsMap);
      // this.listDataTable = newData;
      const newData = this.filterDataByCheckedColumns(checkedColumnsMap);
      this.listDataTable.set(newData);
    }

    this.updateColumns(updatedColumns);
  }

  // 7. Crea un mapa de las columnas seleccionadas
  private getCheckedColumnsMap(updatedColumns: ListDataColumnsI[]): Record<string, boolean> {
    return (updatedColumns ?? [])
      .filter((col) => col.checked)
      .reduce((acc: Record<string, boolean>, col: ListDataColumnsI) => {
        acc[col.title] = true;
        return acc;
      }, {});
  }

  // 8. Filtra los datos de la tabla según las columnas seleccionadas
  private filterDataByCheckedColumns(checkedColumnsMap: Record<string, boolean>): any[] {
    return (this.listDataTableClone() ?? []).map((item: any) => {
      const filteredItem = Object.keys(item)
        .filter((key) => checkedColumnsMap[key])
        .reduce((obj: Record<string, unknown>, key: string) => {
          obj[key] = item[key];
          return obj;
        }, {});
      return filteredItem;
    });
  }

  // 9. Limpia la tabla y mantiene solo la columna 'id'
  private clearTableExceptId(): void {
    // this.listDataTable = [];
    this.listDataTable.set([]);
    this.toggleAllCheckboxes(false);

    // Mantiene solo 'id' seleccionado
    this.checkColumnsOriginal = (this.checkColumnsOriginal ?? []).map((column: any) => ({
      ...column,
      checked: column.title === 'id',
    }));
    this.updatedColumns(this.checkColumnsOriginal);
  }

  // 10. Actualiza las columnas visibles en el formulario
  private updateVisibleColumns(): void {
    const updatedColumns = this.listDataColumns() ?? [];
    const visibleColumns = updatedColumns.filter((col) => col.checked).map((col) => col.title);
    this.initFilterTable(visibleColumns);
  }

  // 11. Actualiza las columnas y guarda el nuevo estado
  private updatedColumns(updatedColumns: ListDataColumnsI[]): void {
    this.listDataColumns.set(updatedColumns);
    this.checkColumnsFilter.set(updatedColumns);
  }

  private toggleAllCheckboxes(checked: boolean): void {
    // Se actualizan todas las columnas según el estado de 'Todos'
    const updatedColumns = (this.listDataColumns() ?? []).map((column: ListDataColumnsI) => ({
      ...column,
      checked: checked,
    }));

    if (checked) {
      // Se restauran todos los datos si se selecciona "Todos"
      this.listDataTable.set(this.listDataTableClone());
    } else {
      // Se limpian los datos si se deselecciona "Todos"
      this.listDataTable.set([]);
    }

    this.updateColumns(updatedColumns);
  }

  private updateColumns(updatedColumns: any): void {
    this.listDataColumns.set(updatedColumns);
    this.checkColumnsFilter.set(updatedColumns);
    this.filterColumns(updatedColumns);

    // Si todas las columnas excepto 'Todos' están seleccionadas, se marca 'Todos'
    const allChecked = (updatedColumns ?? []).slice(1).every((col: any) => col.checked);
    updatedColumns[0].checked = allChecked;

    if ((updatedColumns ?? []).every((col: ListDataColumnsI) => !col.checked)) {
      this.listDataTable.set([]);
      this.isVisibleActions.set(false);
    } else {
      this.isVisibleActions.set(true);
    }
  }

  private filterColumns(updatedColumns: any[]): void {
    // this.filterTableForm.reset();
    // Se excluye 'Todos' para evitar que se muestre en los títulos de las columnas
    const deleteTitleTodos = updatedColumns.filter((item: any) => item.title !== 'Todos');

    // Se obtienen los títulos de las columnas seleccionadas
    const titlesTrue = deleteTitleTodos.filter((element: any) => element.checked).map((item: any) => item.title);

    this.columnsHeaderTable = titlesTrue;
    this.columnsHeaderTableClone = titlesTrue;

    // Se forza la detección de cambios y se reinicia la tabla
    this._cd.markForCheck();
    this.initFilterTable(titlesTrue);
  }

  private initFilterTable(keys: string[]): void {
    this._cd.markForCheck();

    const formGroupConfig: Record<string, any> = {};

    // const isNumber = keys.includes('Código') ? 'Código' : 0;
    // const isString = keys.filter(key => key !== isNumber);

    keys.forEach((key) => {
      // if (this.isFieldNumeric(key)) {
      if (false) {
        // formGroupConfig[isNumber] = new FormControl('', [Validators.pattern('^[0-9]*$')]);
      } else {
        formGroupConfig[key] = new FormControl('', [Validators.pattern('^[a-zA-Z0-9 ]*$')]);
      }
    });
    this._cd.markForCheck();

    if (Object.keys(formGroupConfig).length > 0) {
      this.filterTableForm = this._fb.group(formGroupConfig);
    }
    this._cd.markForCheck();
    // this.listenFilterTableForm();
  }

  // TODO: No borrar, es para agregar la validación de campos numéricos

  // private initFilterTable(keys: string[]): void {

  //   const formGroupConfig: Record<string, any> = {};

  //   // Definir las claves que deberían ser numéricas y las que deberían ser strings
  //   const isNumber = ['Código']; // Campos que deben ser numéricos
  //   const isString = ['Denominación']; // Campos que deben ser string

  //   // Asignar controles para los campos que son numéricos
  //   keys.forEach(key => {
  //     if (isNumber.includes(key)) {
  //       formGroupConfig[key] = new FormControl('', [Validators.pattern('^[0-9]*$')]); // Solo números
  //     } else if (isString.includes(key)) {
  //       // Asignar controles para los campos que son de tipo string
  //       formGroupConfig[key] = new FormControl('', [Validators.pattern('^[a-zA-Z0-9 ]*$')]); // Números y letras
  //     }
  //   });

  //   // Asignar el FormGroup solo si hay controles creados
  //   if (Object.keys(formGroupConfig).length > 0) {
  //     this.filterTableForm = this._fb.group(formGroupConfig);
  //   }
  //   this._cd.markForCheck();
  // }

  // TODO: No borrar

  // private canShowToast = true;

  // // Method to allow only numeric input in a field
  // public onlyAllowNumbers(event: KeyboardEvent): void {
  //   const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'];
  //   const key = event.key;

  //   if (!allowedKeys.includes(key) && !/^\d$/.test(key)) {
  //     if (this.canShowToast) {
  //       this._toastr.warning('Solo se permiten números.', 'Advertencia');
  //       this.canShowToast = false;

  //       setTimeout(() => {
  //         this.canShowToast = true;
  //       }, 6000); // 6000 ms = 6 seconds
  //     }

  //     event.preventDefault();
  //   }
  // }

  // private listenFilterTableForm(): void {
  //   if (this.filterTableForm) {
  //     this.filterTableForm.valueChanges.subscribe((formValues) => {
  //       console.log( formValues);

  //       if(Object.keys(formValues).length === 0) {
  //         return;
  //       }

  //       Object.keys(formValues).forEach(key => {
  //         console.log(`Campo: ${key}, Valor: ${formValues[key]}`);
  //       });
  //     });
  //   } else {
  //     console.warn('El formulario reactivo no está inicializado.');
  //   }
  // }

  public busquedaAnidada(): void {
    const rawData = this.filterTableForm.getRawValue();
    delete rawData?.id;
    const dataForm = Object.entries(rawData).reduce<Record<string, any>>((acc, [key, value]) => {
      acc[key] = typeof value === 'string' ? value.trim() : value;
      return acc;
    }, {});

    this.dataFormSearch.set(dataForm);
    const searchForm = true;
    this.isExisteDataSearchForm.set(false);
    this._tableSvc.setBusquedaAnidada({ ...dataForm, searchForm });
    this.clearOtherFilters();
  }

  private clearOtherFilters(): void {
    this.listDataTableClone.set([]);
    const filterKeys = Object.keys(this.filterTableForm.controls);
    filterKeys.forEach((key) => {
      this.filterTableForm.get(key)?.setValue('', { emitEvent: false });
    });
    this._cd.markForCheck();
  }

  public handleKeyup(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      this.busquedaAnidada();
    }
  }

  public orderBy(column: string): void {
    if (this.sortedColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortDirection = 'asc';
    }

    const data = this.listDataTable();
    data.sort((a, b) => this.compareValues(a[column], b[column]));

    this._cd.markForCheck();
  }

  private compareValues(valueA: any, valueB: any): number {
    if (valueA == null && valueB == null) return 0;
    if (valueA == null) return this.sortDirection === 'asc' ? -1 : 1;
    if (valueB == null) return this.sortDirection === 'asc' ? 1 : -1;

    const isNumA = !isNaN(parseFloat(valueA)) && isFinite(valueA);
    const isNumB = !isNaN(parseFloat(valueB)) && isFinite(valueB);
    if (isNumA && isNumB) {
      const numA = parseFloat(valueA);
      const numB = parseFloat(valueB);
      return this.sortDirection === 'asc' ? numA - numB : numB - numA;
    }

    const dateA = this.parseDate(valueA);
    const dateB = this.parseDate(valueB);
    if (dateA !== null && dateB !== null) {
      return this.sortDirection === 'asc' ? dateA - dateB : dateB - dateA;
    }

    if (typeof valueA === 'string' && typeof valueB === 'string') {
      const comparison = valueA.localeCompare(valueB, undefined, { numeric: true });
      return this.sortDirection === 'asc' ? comparison : -comparison;
    }

    if (typeof valueA === 'boolean' && typeof valueB === 'boolean') {
      const comparison = Number(valueA) - Number(valueB); // false=0, true=1
      return this.sortDirection === 'asc' ? comparison : -comparison;
    }

    const comparison = String(valueA).localeCompare(String(valueB), undefined, { numeric: true });
    return this.sortDirection === 'asc' ? comparison : -comparison;
  }

  private parseDate(value: any): number | null {
    if (typeof value !== 'string') return null;

    const isoDate = Date.parse(value); // Formato ISO: 2024-07-17T18:12:34
    if (!isNaN(isoDate)) return isoDate;

    const customFormat1 = value.match(/^(\d{2})\/(\d{2})\/(\d{4})$/); // Formato: DD/MM/YYYY
    if (customFormat1) {
      const [_, day, month, year] = customFormat1;
      return new Date(`${year}-${month}-${day}`).getTime();
    }

    const customFormat2 = value.match(/^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2})$/); // Formato: DD/MM/YYYY HH:MM
    if (customFormat2) {
      const [_, day, month, year, hour, minute] = customFormat2;
      return new Date(`${year}-${month}-${day}T${hour}:${minute}`).getTime();
    }

    return null;
  }

  public orderByEcvent(event: KeyboardEvent, column: string): void {
    if (event.key === 'Enter') {
      this.orderBy(column);
      event.preventDefault();
    }
  }

  private obtenerFormatoFecha(fecha: Date): string {
    const dia = fecha.getDate().toString().padStart(2, '0');
    const mes = (fecha.getMonth() + 1).toString().padStart(2, '0');
    const anio = fecha.getFullYear();
    return `${dia}/${mes}/${anio}`;
  }

  private obtenerFormatoHora(fecha: Date): string {
    const hora = fecha.getHours().toString().padStart(2, '0');
    const minuto = fecha.getMinutes().toString().padStart(2, '0');
    const segundo = fecha.getSeconds().toString().padStart(2, '0');
    return `${hora}:${minuto}:${segundo}`;
  }

  public toggleBtnVert(dato: any, index: number) {
    this.listDataTable.set(
      this.listDataTable().map((dato) => ({
        ...dato,
        isShowBtnVert: false,
      })),
    );
    const updatedList = this.listDataTable().map((item, i) => (i === index ? { ...item, isShowBtnVert: !dato.isShowBtnVert } : item));
    this.listDataTable.update(() => updatedList);
  }

  public handleKeydown(event: KeyboardEvent): void {
    if (event.key === 'Enter' || event.key === ' ') {
      this.isShowColumn = !this.isShowColumn;
      event.preventDefault();
    }
  }

  // Consulta la entidad activa para descargar el archivo
  private getEntityName(): string {
    let entityName = '';
    this._tableSvc.entityName$.subscribe((name: string) => {
      this.entityName.set(name);
      entityName = name;
    });
    return entityName;
  }

  // ================= Descargar archivo =================

  public estaSeguroDescargarArchivo(): void {
    const data = 'descargar';
    const action = 'descargar';
    const message = this._msg.esta_seguro_descargar;
    const dialogRef = this._dialog.open(EstaSeguroComponent, {
      disableClose: true,
      width: '600px',
      data: { data, action, message },
      autoFocus: false,
      restoreFocus: false,
    });

    dialogRef.afterClosed().subscribe((dataResp: RespDialogI) => {
      if (!dataResp) return;
      if (dataResp.action === 'descargar') {
        this.descargarReporte();
      }
    });
  }

  private descargarReporte(): void {
    const customDownload = this.customDownload();
    const inputsForm = Object.keys(this.filterTableForm.controls).filter((key) => key !== 'id');
    const nameHeaderTable = this.nameHeaderTable();
    const namesBody = Object.keys(nameHeaderTable).filter((key) => inputsForm.includes(nameHeaderTable[key]));
    const namesHeader = Object.values(nameHeaderTable).filter((value) => inputsForm.includes(value));
    const orderBy = Object.keys(nameHeaderTable).filter((key) => this.sortedColumn.includes(nameHeaderTable[key]))[0];

    if (customDownload === true) {
      this._tableSvc.setCustomDownload([{ namesBody, customDownload }]);
      return;
    }

    if (this.isExisteDataSearchForm()) {
      this.descargarSinFiltro(namesBody, namesHeader, orderBy);
    } else {
      this._tableSvc.searchedData$.pipe(take(1)).subscribe((data: string) => {
        const dataString = Object.values(data)[0] as string;
        const existeComa = dataString?.includes(',') || '';
        const dataObject = existeComa
          ? Object.fromEntries(
              dataString.split(',').map((pair: string) => {
                const [key, value] = pair.split('=');
                return [key.trim(), value?.trim() || ''];
              }),
            )
          : Object.fromEntries(
              [dataString].map((pair: string) => {
                const [key, value] = pair.split('=');
                return [key.trim(), value?.trim() || ''];
              }),
            );

        const filters = Object.entries(dataObject).map(([key, value]) => {
          return {
            field: key,
            value: value,
          };
        });
        const searchFatherChidren: { field: string; value: string }[] = this._tableSvc.getSearchFatherChidren() as { field: string; value: string }[];
        const existSearchFatherChidren = searchFatherChidren.length > 0;
        const addFilters = existSearchFatherChidren ? [...searchFatherChidren, ...filters] : filters;

        const bodyData = {
          entity: this.entityName(),
          fields: Object.values(namesBody),
          alias: Object.values(namesHeader),
          direction: 'asc',
          filters: addFilters,
        };
        this.downloadReport(bodyData, '');
        this._tableSvc.setSearchedData([]);
      });
    }
  }

  private descargarSinFiltro(namesBody: string[], namesHeader: string[] | number[], orderBy: string): void {
    this.isDescargando.set(false);
    const searchFatherChidren: { field: string; value: string }[] = this._tableSvc.getSearchFatherChidren() as { field: string; value: string }[];
    const esxtractData = Object.values(searchFatherChidren);
    const nameChildReport = JSON.stringify(esxtractData[1]);

    const body = {
      entity: this.entityName(),
      fields: namesBody,
      alias: namesHeader,
      direction: 'asc',
      filters: searchFatherChidren.length > 0 ? searchFatherChidren : [],
    };
    this.downloadReport(body, nameChildReport);
  }

  private downloadReport(body: any, nameChildReport: string): void {
    this.isDescargando.set(false);

    this._tableSvc.downloadReport(body).subscribe({
      next: (response: string) => {
        this.dataFormSearch.set({});
        this.isDescargando.set(true);
        const validate = Object.keys(response).length;
        if (validate > 0) {
          this.getResourceName(response, nameChildReport);
        } else {
          this._toastr.error(this._msg.archivo_vacio, this._msg.error_descarga_archivo);
        }
        this.filterTableForm.patchValue({});
      },
      error: (error: HttpErrorResponse) => {
        this.isDescargando.set(true);
        if (error.status === 500) {
          this._errorManagementService.status500(error);
        } else if (error.status === 400) {
          const title = 'Se ha producido un error';
          const message = 'Error al descargar el reporte, si el error persiste contacte al administrador';
          this._toastr.error(message, title);
        } else {
          this._errorManagementService.errorGetAll(error);
        }
      },
    });
  }

  public getResourceName(data: string, nameChildReport: string): void {
    const entityName = this.entityName();
    const entityNameConst = entityNameMap;
    const resource = entityNameConst[entityName as keyof typeof entityNameConst] || 'RESOURCE';

    this.downloadCSV(resource, nameChildReport, data);
  }

  private downloadCSV(resource: string, nameChildReport: string, data: string): void {
    const blob = new Blob([data], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;

    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
    const day = currentDate.getDate().toString().padStart(2, '0');
    const hour = currentDate.getHours().toString().padStart(2, '0');
    const minute = currentDate.getMinutes().toString().padStart(2, '0');
    const second = currentDate.getSeconds().toString().padStart(2, '0');
    const dateFile = `${day}-${month}-${year},${hour}-${minute}-${second}`;

    const existNameChildReport = nameChildReport !== undefined && nameChildReport !== '';

    const nameFile = existNameChildReport ? `PJCABA${nameChildReport}${dateFile}` : `PJCABA_${resource}_${dateFile}`;

    link.download = `${nameFile}.csv`;
    link.click();
    window.URL.revokeObjectURL(url);
    this._toastr.success(this._msg.archivo_descargado, this._msg.descarga_exitosa);
    this.dataFormSearch.set({});
  }

  public onPageChange(event: PageEvent): void {
    this.pageChange.emit(event);
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }
}
